import React from 'react';

import Card from './Card';
import { getDeviceFromAccount } from '../helpers/account';
import { mergeSwapDevices } from '../helpers/swaps';
import OrderItem from './OrderItem';

export default ({
  className = 'mb12',
  action,
  order,
  order: { orderId },
  accountData,
}) => {
  const accountDevices = getDeviceFromAccount(accountData);
  const devices = mergeSwapDevices(order, accountDevices);

  return (
    <div>
      <div className={`card-group ${className}`}>
        <div className="card-group__item">
          <Card className="card--action-right-at-768" action={action}>
            <h3 className="mb6">{`Order # ${orderId}`}</h3>
            <span className="status status--warning">Device update order in progress</span>
          </Card>
        </div>
        {
          devices.map(device => (
            <OrderItem device={device} key={device.deviceId} />
          ))
        }
      </div>
    </div>
  );
};
